import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';

class SMOReservationEditViewChannelType extends React.Component {

  selectBoxDidChangeValue(e) {
    this.props.delegate.changeChannelType(e.currentTarget.name, e.currentTarget.value);
  }

  render() {
    const reservation = this.props.reservation;
    const allChannelTypes = this.props.channelTypes;

    let channelTypes = [];
    let selectedValue = null;
    
    for (let i = 0; i < allChannelTypes.length; i++) {
      channelTypes.push({value: allChannelTypes[i].id, label: allChannelTypes[i].name_text});
      if (allChannelTypes[i].id == reservation.channel_type) {
        selectedValue = allChannelTypes[i].id;
      }
    }
    
    return (
        <td>
          <span className="form-select__inner mr10">
            <label className="form-select">
              <SMFormSelectBox
                name="channel_type"
                items={channelTypes}
                selectedValue={selectedValue}
                options={{className: 'w200'}}
                delegate={this} />
            </label>
          </span>
        </td>
    );
  }
}

SMOReservationEditViewChannelType.propTypes = {
  reservation: PropTypes.object.isRequired,
  channelTypes: PropTypes.array.isRequired,
  delegate: PropTypes.object
};
export default SMOReservationEditViewChannelType;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationEditViewChannelType.jsx